import {format, parse} from 'date-fns';

import {DateTimeFormats} from '@/utils/dateFormat';

const EVENT_DATE_FORMAT = 'EEE, LLLL do';
const EVENT_LOCAL_TIME_FORMAT = 'HH:mm:ss';

export const formatEventDate = (eventOn?: string | null): string | null => {
  if (!eventOn) return null;

  return format(parse(eventOn, DateTimeFormats.IsoDateFormat, new Date()), EVENT_DATE_FORMAT);
};

export const formatEventTime = (eventLocalTime?: string | null): string | null => {
  if (!eventLocalTime) return null;

  return format(
    parse(eventLocalTime, EVENT_LOCAL_TIME_FORMAT, new Date()),
    DateTimeFormats.HourWithMinutes,
  );
};
